import { _label as _blockLabel } from '../block/_label'
import { RegexEditor } from '../utils/regex_editor'

const _nolink = /^!?\[(ref)\](?:\[\])?/

export const nolink = new RegexEditor(_nolink)
  .replace('ref', _blockLabel)
  .getRegex()
